// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logo":"LinkedLogo_logo__-ZpeB","logoDesktop":"LinkedLogo_logoDesktop__JJ6Zo","logoMobile":"LinkedLogo_logoMobile__tUIxn"};